<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="generalLang">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <input type="hidden" name="cid" value="">
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.tasktobeDone }}</label>
        </div>
        <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="task_done"
            [ngClass]="formErrorClass(createForm.controls.task_done, createFormSubmitted)" readonly></textarea>
        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.input }}</label>

        </div>
        <div class="form-group col-sm-9">

          <input type="text" class="form-control" formControlName="task_input"
            [ngClass]="formErrorClass(createForm.controls.task_input, createFormSubmitted)" readonly>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.levelofRisk }}</label>
        </div>
        <div class="form-group col-sm-9">
          <select class="form-control" formControlName="risk"
            [ngClass]="formErrorClass(createForm.controls.risk, createFormSubmitted)" readonly>
            <option value="">Select Type</option>
            <option *ngFor="let type of typeConfig" [ngValue]="type.value">{{type.text}}</option>
          </select>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.dateofCreation }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="date" class="form-control" formControlName="creation_date"
            [ngClass]="formErrorClass(createForm.controls.creation_date, createFormSubmitted)" readonly>


        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label> {{ generalLang.expectedClosing }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="date" class="form-control" formControlName="closing_date"
            [ngClass]="formErrorClass(createForm.controls.closing_date, createFormSubmitted)" readonly>


        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.responsible }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="responsible"
            [ngClass]="formErrorClass(createForm.controls.responsible, createFormSubmitted)" readonly>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.documentAttachment }}</label>
        </div>

        <div class="col-sm-9" formArrayName="documentAttachment_uploaded">
          <div class="form-group row" *ngFor="let image of documentAttachment_uploaded().controls; let i=index">
            <div class="col-sm-11">
              <input type="hidden" class="form-control" formControlName="{{i}}">
              <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)"
                value="{{image.value.split('/').pop()}}">

              <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
              <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/consultancy/consultancy_task/{{image.value.split('/').pop()}}"
                target="_blank">{{image.value.split('/').pop()}}</a>

            </div>

          </div>
        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.status }}</label>
        </div>

        <div class="col-sm-9">

          <div *ngIf="record?.status == '1'; else elsepart; ">
            <button class="status_danger">Open</button>
          </div>
          <ng-template #elsepart>
            <button class="status_success">Closed</button>
          </ng-template>
          
        </div>
      </div>

      <div class="form-group col-sm-12" *ngIf="record?.status == '1'; else elsepart1; ">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.daysLeft }}</label>
        </div>

        <div class="col-sm-9">
          {{ record.days_left }}
        </div>
      </div>
      <ng-template #elsepart1>
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.activitiesClosure }}</label>
        </div>
        <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="activities"
            [ngClass]="formErrorClass(createForm.controls.activities, createFormSubmitted)" readonly></textarea>
        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ generalLang?.closingDate }}</label>

        </div>
        <div class="form-group col-sm-9">
          <input type="date" class="form-control" formControlName="close_date"
            [ngClass]="formErrorClass(createForm.controls.close_date, createFormSubmitted)" readonly>
        </div>
      </div>
    </ng-template>



    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="downloadAction(record.task_id,cid)">{{ generalLang?.downloadReport }}</button>
    <button type="button" class="btn btn-danger" (click)="closeTask(record.task_id,cid)"  *ngIf="record?.status == '1'">{{ generalLang?.closeTask
      }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>